import * as XLSX from "xlsx";

/**
 * Загальна функція для експорту даних у Excel.
 * data - масив об'єктів
 * sheetName - назва аркуша
 * fileName - ім'я файлу (з .xlsx)
 * mapFn - функція, яка перетворює кожен об'єкт у формат для таблиці
 */
export const exportToExcel = (data, sheetName, fileName, mapFn) => {
  const worksheet = XLSX.utils.json_to_sheet(data.map(mapFn));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
};

/**
 * Експорт кількох аркушів у один файл Excel.
 * sheets - масив { data, sheetName, mapFn } (mapFn необов'язковий,
 * якщо data вже у форматі рядків для json_to_sheet).
 * fileName - ім'я файлу (з .xlsx)
 */
export const exportMultiSheetToExcel = (sheets, fileName) => {
  const workbook = XLSX.utils.book_new();
  sheets.forEach(({ data, sheetName, mapFn }) => {
    const rows = mapFn ? data.map(mapFn) : data;
    const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  });
  XLSX.writeFile(workbook, fileName);
};
